import React, { useState } from 'react';
import moment from 'moment';
import { Row, Col, Select, Button, Table, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';

const { RangePicker } = DatePicker;

import { imprimirTraspaso } from '../../common/funciones/imprimirReporte';
import { Pagination } from 'antd';

export default ({
  traspasos,
  usuario,
  onDelete,
  history,
  total,
  pagina,
  tamPagina,
  cambiarTamañoPagina,
  cambiarPagina,
  setFiltrarOrganismo,
  filtroOrganismoPadre,
  setFiltrarEstado,
  filtroEstadoPadre,
  listaOrganismos,
  loading,
  onChange,
  onDescargar,
  rangoFechas,
}) => {
  const [filtroOrganismo, setFiltroOrganismo] = useState(filtroOrganismoPadre);
  const [filtroEstado, setFiltroEstado] = useState(filtroEstadoPadre);
  /* Este metodo es encargado de ordenar las fechas.
      @params: a: un objeto traspaso, b: un objeto traspaso.
    */
  const sortFechas = (a, b) => {
    let fechaA = a.fechaReal ? a.fechaReal : a.fechaEstimada;
    let fechaB = b.fechaReal ? b.fechaReal : b.fechaEstimada;
    if (fechaA > fechaB) {
      return 1;
    }
    if (fechaA < fechaB) {
      return -1;
    }

    if (fechaA == fechaB) {
      return 0;
    }
  };

  const columns = [
    {
      title: 'N°',
      key: 'numero',
      render: traspaso => (traspaso.numero ? traspaso.numero : '-'),
    },
    {
      title: 'Fecha',
      key: 'fecha',
      sorter: (a, b) => sortFechas(a, b),
      defaultSortOrder: 'descend',
      render: traspaso =>
        traspaso.fechaReal
          ? moment(traspaso.fechaReal).format('DD-MM-YYYY HH:mm')
          : moment(traspaso.fechaEstimada).format('DD-MM-YYYY HH:mm'),
    },
    {
      title: 'De',
      dataIndex: 'usuarioSaliente',
      render: usuario => usuario.nombre + ' ' + usuario.apellido,
    },
    {
      title: 'Para',
      dataIndex: 'usuarioEntrante',
      render: usuario => usuario.nombre + ' ' + usuario.apellido,
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      render: estado => estado.toUpperCase(),
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Estado:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 180, margin: '10px 18px' }}
                id="estados"
                placeholder="Seleccione el estado"
                onSelect={valor => setFiltroEstado(valor)}
                value={filtroEstado}
              >
                <Select.Option key={'PENDIENTE'}>PENDIENTE</Select.Option>
                <Select.Option key={'Confirmado'}>CONFIRMADO</Select.Option>
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '7px 5px' }}
                onClick={() => setFiltrarEstado(filtroEstado)}
              />
              <Button
                icon={<Icons.EditOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => setFiltrarEstado(null)}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroOrganismo ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Organismo',
      dataIndex: 'organismo',
      render: organismo => organismo.nombre,
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Organismo:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 415, margin: '10px 5px' }}
                id="organismos"
                placeholder="Seleccione el organismo"
                // disabled={usuario.organismo._id !== '00004'}
                onSelect={valor => setFiltroOrganismo(valor)}
                value={filtroOrganismo}
              >
                {listaOrganismos &&
                  listaOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() => setFiltrarOrganismo(filtroOrganismo)}
              />

              <Button
                icon={<Icons.EditOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => setFiltrarOrganismo(null)}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroOrganismo ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (text, record) => (
        <span>
          {record.estado == 'PENDIENTE' &&
          (record.usuarioCreador._id == usuario._id ||
            record.usuarioSaliente == usuario._id) ? (
            <Button
              size="small"
              icon={<Icons.EditOutlined />}
              type="primary"
              style={{ marginRight: 10 }}
              onClick={() => history.push(`/rrhh/traspaso/${record._id}/`)}
            >
              Editar
            </Button>
          ) : null}

          {record.estado == 'Confirmado' ? (
            <Button
              size="small"
              icon={<Icons.EyeOutlined />}
              type="primary"
              style={{ marginRight: 10 }}
              onClick={() => history.push(`/rrhh/traspaso/${record._id}/ver`)}
            >
              Ver
            </Button>
          ) : null}

          {record.estado == 'Confirmado' ? (
            <Button
              size="small"
              icon={<Icons.PrinterOutlined />}
              type="primary"
              style={{ marginRight: 10 }}
              onClick={() =>
                imprimirTraspaso(record, moment().format('DD/MM/YYYY HH:mm'))
              }
            >
              Imprimir
            </Button>
          ) : null}

          {record.estado == 'PENDIENTE' &&
          record.usuarioEntrante &&
          record.usuarioEntrante._id == usuario._id ? (
            <Button
              size="small"
              type="primary"
              icon={<Icons.CheckOutlined />}
              style={{ marginRight: 10 }}
              onClick={() =>
                history.push(`/rrhh/traspaso/${record._id}/confirmar`)
              }
            >
              Recibir
            </Button>
          ) : null}

          {record.estado == 'Confirmado' &&
          record.numero &&
          (usuario.rol === 'DGJP_DIRECTOR' ||
            usuario.rol === 'DGJP_EMPLEADO' ||
            usuario.rol === 'SUPERVISOR') ? (
            <Button
              size="small"
              type="primary"
              icon={<Icons.FileOutlined />}
              style={{ marginRight: 10 }}
              onClick={() =>
                history.push(`/rrhh/traspaso/${record._id}/precargar`)
              }
            >
              Certificacion
            </Button>
          ) : null}

          {record.certificaciones.length > 0 ? null : (
            <Button
              size="small"
              icon={<Icons.DeleteOutlined />}
              type="danger"
              onClick={() => onDelete(record._id)}
            >
              Eliminar
            </Button>
          )}
        </span>
      ),
    },
  ];

  const pagination = {
    onChange: page => {
      cambiarPagina(page);
    },
    total: total,
    current: pagina,
    pageSize: tamPagina ? tamPagina : null,
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      cambiarTamañoPagina(pageSize);
      cambiarPagina(1);
    },
  };

  const descargar = () => {
    onDescargar();
  };

  return (
    <Table
      rowKey="_id"
      columns={columns}
      pagination={pagination}
      dataSource={traspasos}
      loading={loading}
      title={() => (
        <div>
          <h2 style={{ textAlign: 'center' }}> Traspasos </h2>
          <Row style={{ marginTop: 15 }}>
            <Col offset={6}>
              <Row>
                <Col span={6}>
                  <h4>Rango de Fechas: </h4>
                </Col>
                <Col span={16}>
                  <RangePicker
                    style={{ width: 350, marginLeft: 5 }}
                    onChange={onChange}
                    format={'DD-MM-YYYY'}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Button
                style={{ marginLeft: 15 }}
                type="primary"
                onClick={descargar}
                disabled={
                  rangoFechas.fechaInicial === '' &&
                  rangoFechas.fechaFinal === ''
                }
              >
                <Icons.DownloadOutlined />
                Descargar Reporte
              </Button>
            </Col>
          </Row>
        </div>
      )}
      locale={{
        emptyText: 'Sin traspasos.',
      }}
    />
  );
};
